import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=c7c67942&scoped=true&"
import script from "./NotFoundPage.vue?vue&type=script&lang=ts&"
export * from "./NotFoundPage.vue?vue&type=script&lang=ts&"
import style0 from "./NotFoundPage.vue?vue&type=style&index=0&id=c7c67942&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c67942",
  null
  
)

export default component.exports